// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ExtEnrollmentCardInfoModel {
    static getAttributeTypeMap() {
        return ExtEnrollmentCardInfoModel.attributeTypeMap;
    }
}
ExtEnrollmentCardInfoModel.discriminator = undefined;
ExtEnrollmentCardInfoModel.additionalProperties = false;
ExtEnrollmentCardInfoModel.attributeTypeMap = [
    {
        "name": "cardLastFourDigits",
        "baseName": "cardLastFourDigits",
        "type": "string"
    },
    {
        "name": "expirationDate",
        "baseName": "expirationDate",
        "type": "string"
    },
];
//# sourceMappingURL=extEnrollmentCardInfoModel.js.map